<script setup lang="ts">
import { IonContent, IonPage } from '@ionic/vue';
import logoUrl from '/assets/logo.png';
</script>

<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <main class="auth-container">
        <section class="auth-card">
          <div class="logo-section">
            <img :src="logoUrl" alt="Bwell Logo" class="logo" />
          </div>

          <slot />

          <footer class="footer-section">
            <a
              href="https://bwellacademy.com/integritetspolicy/"
              target="_blank"
              rel="noopener noreferrer"
              class="footer-link"
            >
              {{ $t('privacyPolicy') }}
            </a>
            <div class="divider"></div>
            <p class="copyright">{{ $t('LoginPage.copyright') }}</p>
          </footer>
        </section>

        <div class="decoration decoration-1"></div>
        <div class="decoration decoration-2"></div>
        <div class="decoration decoration-3"></div>
      </main>
    </ion-content>
  </ion-page>
</template>

<style scoped>
ion-content {
  --background: linear-gradient(135deg, #fffafd 0%, #fff5fa 100%);
  --padding-top: 0;
  --padding-bottom: 0;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}

.auth-container {
  min-height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  position: relative;
  overflow: hidden;
}

.auth-card {
  background: #fff;
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  position: relative;
  z-index: 10;
}

.logo-section {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.logo {
  width: 88px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.05));
}

.footer-section {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.footer-link {
  color: #7b1fa2;
  font-size: 0.75rem;
  text-decoration: none;
}

.footer-link:hover {
  color: #6a1b9a;
  text-decoration: underline;
}

.divider {
  width: 50px;
  height: 1px;
  background-color: #e5e7eb;
}

.copyright {
  margin: 0;
  font-size: 0.75rem;
  color: #9ca3af;
  text-align: center;
}

.decoration {
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  opacity: 0.5;
  pointer-events: none;
}

.decoration-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(
    135deg,
    rgba(123, 31, 162, 0.1),
    rgba(123, 31, 162, 0.05)
  );
  top: -100px;
  right: -100px;
}

.decoration-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(
    135deg,
    rgba(123, 31, 162, 0.08),
    rgba(123, 31, 162, 0.03)
  );
  bottom: -50px;
  left: -50px;
}

.decoration-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(
    135deg,
    rgba(123, 31, 162, 0.06),
    rgba(123, 31, 162, 0.02)
  );
  top: 40%;
  left: 25%;
  transform: translateX(-50%);
}

@media (min-width: 768px) {
  .auth-card {
    padding: 2.5rem;
  }

  .logo {
    width: 100px;
  }
}
</style>
